<template>
	<div class="__record px-10 pb-30 md-down:px-4">
		<div
			class="
				__record__header
				pt-10
				pb-6
				flex flex-nowrap
				justify-between
				items-center
				md-down:flex-col md-down:items-start
				gap-10
				md-down:gap-4
			"
		>
			<div class="flex flex-nowrap items-center w-full justify-between">
				<div
					class="
						__record__title
						text-neutral-500
						font-semibold
						whitespace-nowrap
						flex flex-nowrap
						items-center
						text-4xl
						cursor-pointer
						gap-3
					"
				>
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_17472_32430)">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5.25132 4.60756V3.48133C5.25132 3.31791 5.21914 3.15608 5.1566 3.0051C5.09406 2.85412 5.0024 2.71693 4.88684 2.60137C4.77128 2.48581 4.63409 2.39415 4.4831 2.33161C4.33212 2.26907 4.17029 2.23689 4.00687 2.23689H2.48861C2.48862 1.64363 2.72429 1.07467 3.1438 0.655171C3.5633 0.235674 4.13226 2.47525e-06 4.72552 0H25.1406C25.4344 0 25.7253 0.0578596 25.9966 0.170274C26.268 0.282689 26.5146 0.447457 26.7223 0.655172C26.9301 0.862886 27.0948 1.10948 27.2072 1.38087C27.3196 1.65226 27.3775 1.94314 27.3775 2.23689V25.7631C27.3775 26.0569 27.3196 26.3477 27.2072 26.6191C27.0948 26.8905 26.9301 27.1371 26.7223 27.3448C26.5146 27.5525 26.268 27.7173 25.9967 27.8297C25.7253 27.9421 25.4344 28 25.1406 28H4.72552C4.13226 28 3.5633 27.7643 3.1438 27.3448C2.7243 26.9253 2.48862 26.3564 2.48861 25.7631H4.00687C4.17029 25.7631 4.33212 25.7309 4.4831 25.6684C4.63409 25.6059 4.77128 25.5142 4.88683 25.3986C5.00239 25.2831 5.09406 25.1459 5.15659 24.9949C5.21913 24.8439 5.25132 24.6821 5.25131 24.5187V23.3924C5.25132 23.229 5.21913 23.0672 5.15659 22.9162C5.09406 22.7652 5.00239 22.628 4.88683 22.5125C4.77128 22.3969 4.63409 22.3053 4.4831 22.2427C4.33212 22.1802 4.17029 22.148 4.00687 22.148H2.48861V20.7853H4.00687C4.17029 20.7853 4.33212 20.7532 4.4831 20.6906C4.63409 20.6281 4.77128 20.5364 4.88683 20.4209C5.00239 20.3053 5.09406 20.1681 5.15659 20.0171C5.21913 19.8661 5.25132 19.7043 5.25131 19.5409V18.4147C5.25132 18.2512 5.21913 18.0894 5.15659 17.9384C5.09406 17.7875 5.00239 17.6503 4.88683 17.5347C4.77128 17.4191 4.63409 17.3275 4.4831 17.2649C4.33212 17.2024 4.17029 17.1702 4.00687 17.1702H2.48861V15.8076H4.00687C4.17029 15.8076 4.33212 15.7754 4.4831 15.7128C4.63409 15.6503 4.77128 15.5586 4.88683 15.4431C5.00239 15.3275 5.09406 15.1903 5.15659 15.0393C5.21913 14.8884 5.25132 14.7265 5.25131 14.5631V13.4369C5.25132 13.2735 5.21913 13.1116 5.15659 12.9607C5.09406 12.8097 5.00239 12.6725 4.88683 12.5569C4.77128 12.4414 4.63409 12.3497 4.4831 12.2872C4.33212 12.2246 4.17029 12.1924 4.00687 12.1924H2.48861V10.8298H4.00687C4.17029 10.8298 4.33212 10.7976 4.4831 10.7351C4.63409 10.6725 4.77128 10.5809 4.88683 10.4653C5.00239 10.3497 5.09406 10.2126 5.15659 10.0616C5.21913 9.91058 5.25132 9.74876 5.25131 9.58533V8.45911C5.25132 8.29569 5.21913 8.13386 5.15659 7.98288C5.09406 7.83189 5.00239 7.69471 4.88683 7.57915C4.77128 7.46359 4.63409 7.37193 4.4831 7.30939C4.33212 7.24685 4.17029 7.21466 4.00687 7.21467H2.48861V5.852H4.00688C4.1703 5.852 4.33212 5.81982 4.48311 5.75728C4.63409 5.69474 4.77128 5.60308 4.88684 5.48752C5.0024 5.37196 5.09406 5.23477 5.1566 5.08379C5.21914 4.9328 5.25132 4.77098 5.25132 4.60756Z"
								fill="#94A3B8"
							/>
							<path
								d="M4.00828 3.17074H0.93367C0.761848 3.17074 0.622559 3.31002 0.622559 3.48185V4.60713C0.622559 4.77896 0.761848 4.91825 0.93367 4.91825H4.00828C4.18011 4.91825 4.3194 4.77896 4.3194 4.60713V3.48185C4.3194 3.31002 4.18011 3.17074 4.00828 3.17074Z"
								fill="#94A3B8"
							/>
							<path
								d="M0.93367 13.1263H4.00828C4.18011 13.1263 4.3194 13.2656 4.3194 13.4374V14.5627C4.3194 14.7345 4.18011 14.8738 4.00828 14.8738H0.93367C0.761848 14.8738 0.622559 14.7345 0.622559 14.5627V13.4374C0.622559 13.2656 0.761848 13.1263 0.93367 13.1263Z"
								fill="#94A3B8"
							/>
							<path
								d="M4.00828 8.14851H0.93367C0.761848 8.14851 0.622559 8.2878 0.622559 8.45963V9.58491C0.622559 9.75674 0.761848 9.89602 0.93367 9.89602H4.00828C4.18011 9.89602 4.3194 9.75674 4.3194 9.58491V8.45963C4.3194 8.2878 4.18011 8.14851 4.00828 8.14851Z"
								fill="#94A3B8"
							/>
							<path
								d="M4.00828 18.1041H0.93367C0.761848 18.1041 0.622559 18.2434 0.622559 18.4152V19.5405C0.622559 19.7123 0.761848 19.8516 0.93367 19.8516H4.00828C4.18011 19.8516 4.3194 19.7123 4.3194 19.5405V18.4152C4.3194 18.2434 4.18011 18.1041 4.00828 18.1041Z"
								fill="#94A3B8"
							/>
							<path
								d="M4.00828 23.0818H0.93367C0.761848 23.0818 0.622559 23.2211 0.622559 23.393V24.5182C0.622559 24.6901 0.761848 24.8294 0.93367 24.8294H4.00828C4.18011 24.8294 4.3194 24.6901 4.3194 24.5182V23.393C4.3194 23.2211 4.18011 23.0818 4.00828 23.0818Z"
								fill="#94A3B8"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19.4809 5.08203L23.2944 8.8955L19.4809 12.709L18.3352 11.5632L20.1928 9.70566L13.237 9.70565C11.8947 9.70565 10.8066 10.7938 10.8066 12.1361V12.9463C10.8066 13.3937 10.4438 13.7564 9.99641 13.7564C9.54897 13.7564 9.18626 13.3937 9.18626 12.9463V12.1361C9.18626 9.89894 10.9998 8.08535 13.237 8.08535L20.1928 8.08535L18.3352 6.22776L19.4809 5.08203ZM21.3385 13.7564C21.786 13.7564 22.1487 14.1191 22.1487 14.5666V15.3767C22.1487 17.6139 20.3351 19.4275 18.0979 19.4275H11.1421L12.9997 21.2851L11.854 22.4308L8.04053 18.6173L11.854 14.8039L12.9997 15.9496L11.1421 17.8072H18.0979C19.4402 17.8072 20.5284 16.719 20.5284 15.3767V14.5666C20.5284 14.1191 20.8911 13.7564 21.3385 13.7564Z"
								fill="white"
							/>
						</g>
						<defs>
							<clipPath id="clip0_17472_32430">
								<rect width="28" height="28" fill="white" />
							</clipPath>
						</defs>
					</svg>

					<span class="mt-1.5">Hồ sơ chuyển cơ sở</span>
				</div>
				<div class="search-input w-72">
					<div class="input-group input--lg">
						<input
							type="text"
							placeholder="Gõ tên học sinh để bắt đầu tìm kiếm"
							class="bg-white input-with-icon"
						/>
						<div class="input-icon absolute top-1/2">
							<DaIcon
								name="das--search"
								class="h-4 w-4 text-neutral-400"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="__record__content" v-if="!isLoading">
			<div
				class="shadow-sm sm:rounded-2xl mt-12"
				v-if="dataTransfers.length"
			>
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="
							overflow-hidden
							sm:rounded-t-2xl
							w-fit
							min-w-full
						"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											w-16
											whitespace-nowrap
										"
									>
										STT
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										Tên học sinh
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										trung tâm cũ
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										trung tâm mới
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										Trạng thái
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(person, personIdx) in dataTransfers"
									:key="personIdx"
									:class="
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="
										text-neutral-700
										hover:bg-orange-50
										cursor-pointer
									"
									@click="toDetail(person)"
								>
									<td>
										<div class="px-6 py-4 text-neutral-700">
											{{ personIdx + 1 }}
										</div>
									</td>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
										style="width: 250px"
									>
										<div class="flex items-center">
											<div class="relative">
												<img
													class="
														shadow-sm
														inline-block
														h-6
														w-6
														rounded-full
													"
													:src="
														person?.old_student
															?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														person?.old_student
															?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="
														inline-flex
														items-center
														justify-center
														h-6
														w-6
														rounded-full
													"
													:style="{
														background:
															person?.old_student
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="
															font-medium
															leading-none
															text-white text-xs
														"
														>{{
															person?.old_student
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
												<div
													v-if="
														!(
															current_org.org_id ===
															person?.new_org
																?.org_id
														)
													"
													style="
														background-color: rgba(
															241,
															162,
															103,
															0.5
														);
													"
													class="
														absolute
														transform
														-translate-x-1/2
														-translate-y-1/2
														top-1/2
														left-1/2
														h-6
														w-6
														rounded-full
														flex
														items-center
														justify-center
													"
												>
													<svg
														width="14"
														height="14"
														viewBox="0 0 40 40"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
															fill="#FAF5F1"
														/>
													</svg>
												</div>
											</div>
											<div
												class="
													ml-4
													text-orange-600
													font-semibold
												"
											>
												{{ person?.old_student.name }}
											</div>
											<span
												v-if="person.show_toast"
												class="
													px-3.5
													py-1
													bg-indigo-100
													rounded-full
													text-sm
													ml-3
												"
												>Mới</span
											>
										</div>
									</td>
									<td>
										<div
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											{{ person?.old_org?.name }}
										</div>
									</td>
									<td>
										<div class="px-6 py-4 text-neutral-700">
											{{ person?.new_org?.name }}
										</div>
									</td>
									<td class="px-6 py-4">
										<div
											v-if="
												current_org.org_id ===
												person?.new_org?.org_id
											"
											class="
												text-neutral-700
												flex
												items-center
												gap-3
												text-sm
											"
										>
											<svg
												width="20"
												height="20"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M5 5.94336V5.94336C5 4.11877 5 3.20648 5.51203 2.63637C5.62315 2.51265 5.74927 2.40327 5.88746 2.31076C6.52425 1.8845 7.42738 2.01352 9.23363 2.27155L11.5152 2.59749C13.9713 2.94837 15.1994 3.1238 15.933 3.9697C16.6667 4.81559 16.6667 6.05612 16.6667 8.53719V11.463C16.6667 13.944 16.6667 15.1846 15.933 16.0305C15.1994 16.8764 13.9713 17.0518 11.5152 17.4027L9.07037 17.7519C7.41879 17.9879 6.593 18.1058 5.99127 17.7544C5.77673 17.6291 5.58742 17.4649 5.43303 17.2702C5 16.7242 5 15.8901 5 14.2217V14.2217"
													stroke="#41BEAD"
													stroke-width="2"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M9.16667 5.83325L12.5 9.99992M12.5 9.99992L9.16667 14.1666M12.5 9.99992H2.5"
													stroke="#41BEAD"
													stroke-width="2"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
											<span>Đã nhận</span>
										</div>
										<div
											v-else
											class="
												text-neutral-700
												flex
												items-center
												gap-3
												text-sm
											"
										>
											<svg
												width="20"
												height="20"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M5.20833 5.83325L3.54167 7.91659L1.875 9.99992M1.875 9.99992L5.20833 14.1666M1.875 9.99992H9.375"
													stroke="#41BEAD"
													stroke-width="2"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
												<path
													d="M8.5415 6.77669V6.61406C8.5415 5.1012 8.5415 4.34477 8.95917 3.80447C8.99566 3.75726 9.03425 3.71171 9.07482 3.66795C9.53909 3.16715 10.2852 3.04279 11.7775 2.79408V2.79408C14.8069 2.28917 16.3217 2.03672 17.3512 2.81546C17.4394 2.88215 17.5238 2.95366 17.6041 3.02967C18.5415 3.91721 18.5415 5.45282 18.5415 8.52404V11.4761C18.5415 14.5473 18.5415 16.083 17.6041 16.9705C17.5238 17.0465 17.4394 17.118 17.3512 17.1847C16.3217 17.9634 14.8064 17.7109 11.776 17.2058V17.2058C10.2854 16.9574 9.54014 16.8332 9.07611 16.3336C9.03464 16.289 8.99523 16.2424 8.95801 16.1942C8.5415 15.6543 8.5415 14.899 8.5415 13.3884V13.3884"
													stroke="#41BEAD"
													stroke-width="2"
													stroke-linecap="round"
												/>
											</svg>

											<span>Đã chuyển</span>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import Loading from '@/components/common/Loading';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import { $api } from '@/services';

export default {
	name: 'TransferredData',

	components: { DaIcon, Loading },

	data() {
		return {
			isLoading: false,
			dataTransfers: [],
		};
	},

	computed: {
		hideToast() {
			return Boolean(this.$route.query.hide_toast);
		},

		current_org() {
			return this.$store.state.profile.current_org;
		},
	},

	created() {
		this.fetchOrgTransferredHistory();
		if (this.hideToast) {
			this.hideLabelOrgTransferHistory();
		}
	},

	methods: {
		async fetchOrgTransferredHistory() {
			try {
				const {
					data: { data },
				} = await $api.student.fetchOrgTransferredHistory();
				this.dataTransfers = data;
			} catch (e) {
				console.log(e);
			}
		},

		async hideLabelOrgTransferHistory() {
			try {
				await $api.student.hideLabelOrgTransferHistory();
				await this.$store.dispatch('setAlertMessageDontHide', {
					message: '',
					type: 'error',
				});
			} catch (e) {
				console.log(e);
			}
		},

		toDetail(person) {
			if (this.current_org.org_id === person?.new_org?.org_id) {
				return this.$router.push(
					`/record/student/${person.new_student_id}/staff-list`
				);
			}
			return this.$router.push({
				path: `/record/student/${person?.old_student_id}/staff-list`,
				query: {
					org: person?.old_org.subdomain,
					org_id: person?.old_org.org_id,
					is_old_data: 'true',
					join_date: person?.join_date,
					left_date: person?.left_date,
					action: 'full-screen',
					new_id: person.old_student_id,
				},
			});
		},
	},
};
</script>
